import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const state = {
	propertyData: {},
  orderFormData: {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    address: "",
    pin: "",
    homePurchased: "No",
    purchaseDate: "",
    purchaseAmount: "",
  },
  caseData: {
    address: "",
    contactName: null,
    createdOn: "",
    filingOption: null,
    id: null,
    latitude: null,
    longitude: null,
    modifiedOn: "",
    municipality: "",
    orderStatus: "",
    pass: null,
    pin: "",
    postalCode: null,
    propertyId: null,
    purchaseAmount: null,
    purchaseDate: null,
    state: null,
    statusText: "",
    streetName: "",
    streetNameComplete: null,
    streetNamePostDirection: null,
    streetNamePreDirection: null,
    streetNameType: "",
    streetNumber: "",
    subJurisdictionId: null,
    taxYear: null,
    userId: null,
    uspspn: null,
    x: null,
    y: null,
  },
  isOrderFromEditable: false,
};

export default {
	state,
	getters,
	actions,
	mutations,
};
